import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance30 = () => {
  let winners = ["428"];
  return <IndividualTable matchType={"2"} gender="M" event="30" subTitle="Zamby" data={sampleData} topRankCount="1" winners={winners} />;
};
export default Distance30;
